import { css } from 'lit';

export const styles = css`[part=file-names]{font-size:.875rem}`;
